import Axios from 'axios';
import { getAuthApiBase } from './authBase';

export const searchRolesApi = ({ name, search, keyword, authToken, deviceId, deviceUniqueId, page, size }) => {
    if (authToken != null) {
        const resolvedKeyword =
            keyword != null && keyword !== ''
                ? keyword
                : name != null && name !== ''
                  ? name
                  : search || '';
        return Axios({
            method: 'get',
            url: getAuthApiBase() + 'v2/roles',
            params: {
                keyword: resolvedKeyword,
                page: page != null ? page : 0,
                pageSize: size != null && size !== '' ? size : 10,
            },
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId || deviceUniqueId,
            },
        });
    }
};

export const viewRolesApi = ({ id, authToken, deviceId }) => {
    if (authToken != null) {
        return Axios({
            method: 'get',
            url: getAuthApiBase() + 'v2/roles/' + id,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const createRolesApi = ({ authToken, deviceId, data }) => {
    if (authToken != null) {
        return Axios({
            method: 'post',
            url: getAuthApiBase() + 'v2/roles',
            data: {
                code: data.code,
                name: data.name,
                description: data.description,
                privileges: data.privileges,
            },
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const updateRolesApi = ({ authToken, deviceId, id, data }) => {
    if (authToken != null) {
        return Axios({
            method: 'put',
            url: getAuthApiBase() + 'v2/roles/' + id,
            data: {
                code: data.code,
                name: data.name,
                description: data.description,
                privileges: data.privileges,
            },
            headers: {
                'Content-Type': 'application/json',
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const deleteRolesApi = ({ authToken, deviceId, id }) => {
    if (authToken != null) {
        return Axios({
            method: 'delete',
            url: getAuthApiBase() + 'v2/roles/' + id,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

/** Single page; saga may call twice (pageSize max 100). */
export const getListPrivilegesApi = ({ authToken, deviceUniqueId, deviceId, size, page }) => {
    if (authToken != null) {
        const resolvedDeviceId = deviceUniqueId || deviceId;
        return Axios({
            method: 'get',
            url: getAuthApiBase() + 'v2/privileges',
            params: {
                page: page === undefined || page === null ? 0 : page,
                pageSize: size === undefined || size === null ? 100 : Math.min(size, 100),
            },
            headers: {
                authToken: authToken,
                deviceUniqueId: resolvedDeviceId,
            },
        });
    }
};
